import React from "react"
import { useForm } from "react-hook-form"
import { navigate } from "gatsby"

import { BsChevronRight } from "react-icons/bs"

export default function ContactMeForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  const onSubmit = (data, event) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact-me", ...data }),
    })
      .then(response => {
        navigate("/thankyou/")
        reset()
        console.log(response)
      })
      .catch(error => console.log("ERROR", error))
    event.preventDefault()
  }
  console.log(errors)

  return (
    <form
      className="grid grid-cols-1 gap-6 shadow p-6 bg-white"
      id="contactMeForm"
      onSubmit={handleSubmit(onSubmit)}
      method="POST"
      action="/thankyou/"
      data-netlify="true"
      netlify-honeypot="bot-field"
      name="contact-me"
    >
      <div className="font-playfaird text-xl capitalize">Send me a Message</div>

      <input type="hidden" name="form-name" value="contact-me" />
      <input type="text" name="bot-field" className="hidden" />

      <label className="block">
        <span className="text-slate-700">Your message to me</span>
        <textarea
          name="message"
          className="mt-1 block w-full border border-slate-200"
          rows="3"
          placeholder="type your message here, please"
          {...register("message", { required: true, min: 1 })}
        ></textarea>
        {errors.message && errors.message.type === "required" && (
          <span className="text-xs text-red-700">This field is required</span>
        )}
      </label>

      <label className="block">
        <span className="text-slate-700">Mobile number</span>
        <input
          name="tel"
          type="tel"
          className="mt-1 block w-full border border-slate-200"
          placeholder="(807) XXX-XXXX"
          {...register("tel", {
            required: true,
            minLength: 6,
            maxLength: 12,
          })}
        />
        {errors.tel && errors.tel.type === "required" && (
          <span className="text-xs text-red-700">
            Please check your phone number
          </span>
        )}
      </label>

      <label className="block">
        <span className="text-slate-700">Email</span>
        <input
          name="email"
          type="email"
          className="mt-1 block w-full border border-slate-200"
          placeholder="name@email.ca"
          {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
        />
        {errors.email && (
          <span className="text-xs text-red-700">Please check your email</span>
        )}
      </label>

      <button
        type="submit"
        className="py-3 px-8 font-playfaird tracking-wider uppercase flex items-center justify-center rounded-sm whitespace-nowrap bg-amber-200 text-slate-900 hover:shadow-sm hover:bg-amber-300"
      >
        <span>Send Message</span>
        <BsChevronRight className="ml-2 h-4" />
      </button>
    </form>
  )
}
